"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function SoftwareDeveloperMind() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235931" id="resilienzzentrum-soonwald" className="relative min-h-[80vh] flex items-center justify-center py-24 lg:py-32 overflow-hidden bg-background">
      <div className="absolute inset-0 z-0">
        <img src="https://resilienz-zentrum-soonwald.de/wp-content/uploads/2026/05/IMG_20260522_193504-1-scaled.jpg" alt="Resilienz-Zentrum Soonwald Hintergrund" className="w-full h-full object-cover skip-lazy no-lazy" loading="eager" fetchPriority="high" decoding="sync" />
      </div>
      
      <div className="absolute inset-0 bg-background/40 backdrop-blur-[2px] z-10" />
      
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex flex-col items-center justify-center">
          
          <div ref={textRef} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="text-4xl sm:text-7xl lg:text-8xl xl:text-9xl font-serif font-semibold text-foreground leading-[1.2] mb-8 tracking-tight max-w-5xl mx-auto break-words">Resilienzzentrum Soonwald</h1>
            
            <p className="text-xl mb-12 max-w-3xl leading-relaxed font-default !text-[hsl(0,0%,100%)] !font-medium sm:text-2xl" style={{
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}>Organisation . Psychologie . Bewegung . Natur</p>
            
            <div className="flex flex-wrap justify-center items-center gap-6">
              <Button asChild className="rounded-lg font-default font-semibold text-base px-[32px] py-[12px] bg-[#3d5a3d] text-white hover:bg-[#2d432d] transition-all duration-300">
                <Link to="mailto:post@claudiachrist.de">
                  Kontakt aufnehmen
                </Link>
              </Button>
              
              <Button asChild variant="outline" className="rounded-lg font-default font-semibold text-base px-[32px] py-[12px] border-[#3d5a3d] text-[#3d5a3d] hover:bg-[#3d5a3d]/10 transition-all duration-300">
                <Link to="https://resilienz-zentrum-soonwald.de/aktuelle-termine/">
                  Unser Programm
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}